import { useEffect, useState } from "react";
import { AnimatePresence, motion } from "framer-motion";
import { Tag, X } from "lucide-react";
import { api } from "@/lib/api";

const pad = (n) => String(n).padStart(2, "0");

export const PromoBanner = () => {
  const [promo, setPromo] = useState(null);
  const [dismissed, setDismissed] = useState(false);
  const [now, setNow] = useState(Date.now());

  useEffect(() => {
    api.get("/discounts/banner")
      .then((r) => {
        if (r.data?.code && !sessionStorage.getItem(`promo_banner_${r.data.code}`)) setPromo(r.data);
      })
      .catch(() => {});
  }, []);

  useEffect(() => {
    if (!promo?.expires_at) return;
    const t = setInterval(() => setNow(Date.now()), 1000);
    return () => clearInterval(t);
  }, [promo]);

  const dismiss = () => {
    sessionStorage.setItem(`promo_banner_${promo.code}`, "1");
    setDismissed(true);
  };

  let countdown = "";
  if (promo?.expires_at) {
    const end = new Date(`${promo.expires_at}T23:59:59`).getTime();
    const diff = Math.max(0, end - now);
    const d = Math.floor(diff / 86400000);
    const h = Math.floor((diff % 86400000) / 3600000);
    const m = Math.floor((diff % 3600000) / 60000);
    const s = Math.floor((diff % 60000) / 1000);
    countdown = diff > 0 ? `ends in ${d > 0 ? `${d}d ` : ""}${pad(h)}:${pad(m)}:${pad(s)}` : "ended";
  }

  return (
    <AnimatePresence>
      {promo && !dismissed && (
        <motion.div
          initial={{ height: 0, opacity: 0 }}
          animate={{ height: "auto", opacity: 1 }}
          exit={{ height: 0, opacity: 0 }}
          transition={{ duration: 0.4, ease: [0.22, 1, 0.36, 1] }}
          className="overflow-hidden bg-gradient-to-r from-emerald-400 via-emerald-300 to-emerald-400"
          data-testid="promo-banner"
        >
          <div className="mx-auto flex max-w-7xl items-center justify-center gap-3 px-4 py-2.5 text-center sm:px-6">
            <Tag size={13} className="shrink-0 text-black" />
            <p className="font-mono text-[11px] font-bold uppercase tracking-widest text-black sm:text-xs" data-testid="promo-banner-text">
              Flash sale — {promo.percent}% off all beat leases with code{" "}
              <span className="rounded bg-black/20 px-2 py-0.5">{promo.code}</span>
              {countdown && (
                <span className="ml-2 rounded bg-black/20 px-2 py-0.5 tabular-nums" data-testid="promo-banner-countdown">{countdown}</span>
              )}
            </p>
            <button onClick={dismiss} data-testid="promo-banner-dismiss"
              className="ml-2 shrink-0 rounded-full p-1 text-black/70 transition-colors hover:text-black">
              <X size={14} />
            </button>
          </div>
        </motion.div>
      )}
    </AnimatePresence>
  );
};
